/* SilentoPro : compte a rebours de la barre promo */
(function () {
  if (window.__silentoCountdown) return;
  window.__silentoCountdown = true;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function deadline(el) {
    if (el.dataset.mode === 'date') {
      var t = Date.parse((el.dataset.end || '').replace(' ', 'T'));
      return isNaN(t) ? null : t;
    }
    var mins = parseInt(el.dataset.minutes, 10) || 15;
    // repart a zero a chaque chargement de page
    if (el.dataset.mode === 'reload') return Date.now() + mins * 60000;
    // par visiteur : la meme echeance pendant toute la visite
    var key = 'spc-' + (el.id || 'default');
    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) {}
    if (stored && !isNaN(parseInt(stored, 10))) return parseInt(stored, 10);
    var end = Date.now() + mins * 60000;
    try { sessionStorage.setItem(key, String(end)); } catch (e) {}
    return end;
  }

  function place(el) {
    if (el.dataset.placed) return;
    var bar = document.querySelector('.kaching-bundles__bar');
    if (!bar) return;
    var container = bar.closest('.kaching-bundles') || bar.closest('.kaching-bundles__bars') || bar.parentElement;
    if (!container) return;
    container.parentElement.insertBefore(el, container);
    el.dataset.placed = '1';
  }

  function tick(el, end) {
    var out = el.querySelector('[data-spc-time]');
    var left = end - Date.now();
    if (left <= 0) {
      var mode = el.dataset.onEnd || 'hide';
      if (mode === 'text' && el.dataset.expired) {
        el.querySelector('.spc__label').textContent = el.dataset.expired;
        out.textContent = '';
      } else if (mode === 'zero') {
        out.textContent = '00:00:00';
      } else {
        el.hidden = true;
      }
      return false;
    }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    var txt = pad(h) + ':' + pad(m) + ':' + pad(s % 60);
    if (d > 0) txt = d + (d === 1 ? ' Tag ' : ' Tage ') + txt;
    out.textContent = txt;
    return true;
  }

  function start() {
    document.querySelectorAll('[data-spc]').forEach(function (el) {
      var end = deadline(el);
      if (!end) { el.hidden = true; return; }
      if (!tick(el, end)) return;
      setInterval(function () { tick(el, end); }, 1000);
      place(el);
      var tries = 0;
      var t = setInterval(function () { place(el); if (++tries > 12 || el.dataset.placed) clearInterval(t); }, 400);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
